<div class="palantir-calendar-header">
  <palantir-icon
    class="palantir-calendar-header__button"
    name="chevron-left-outline"
    (click)="renderPreviousMonth()"
  />

  <span class="palantir-calendar-header__title">
    {{ getCurrentFormattedDate() }}
  </span>

  <palantir-icon
    class="palantir-calendar-header__button"
    name="chevron-right-outline"
    (click)="renderNextMonth()"
  />
</div>

<div class="palantir-calendar-content">
  @for (weekday of weekDaysKeys; track weekday) {
    <div class="palantir-calendar-weekday-column">
      <span class="palantir-calendar-weekday-column__title">
        {{ weekday.charAt(0).toUpperCase() }}
      </span>

      @for (day of weekDays[weekday]?.slice(0, 5); track day) {
        <div
          class="palantir-calendar-weekday-column__item"
          [ngClass]="{
            'palantir-calendar-weekday-column__item--is-current-month': day.isCurrentMonth,
            'palantir-calendar-weekday-column__item--is-selected': isSelected(day.date),
            'palantir-calendar-weekday-column__item--is-last-left': isMostOldSelectedDay(day.date),
            'palantir-calendar-weekday-column__item--is-last-right': isMostRecentSelectedDay(
              day.date
            ),
            'palantir-calendar-weekday-column__item--is-only-selected':
              isMostOldSelectedDay(day.date) && isMostRecentSelectedDay(day.date),
            'palantir-calendar-weekday-column__item--selectable': selectable,
          }"
          (click)="onDayClick(day.date)"
          (keydown.enter)="onDayClick(day.date)"
        >
          <span
            class="palantir-calendar-weekday-column__day"
            [ngClass]="{ 'palantir-calendar-weekday-column__day--is-today': isToday(day.date) }"
          >
            {{ day.value }}
          </span>
        </div>
      }
    </div>
  }
</div>
